import { Box, CardMedia, Container, Grid, Typography } from '@mui/material';
import React from 'react'; import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import bodyLeftBg from '../../../../images/Rectangle 302.png';
import testimonial1 from '../../../../images/team-sm1.png';
import testimonial2 from '../../../../images/team-sm2.png';
import testimonial from '../../../../images/Rectangle 207.png';
import connectBg from '../../../../images/connect-bg.png';
import groupBg from '../../../../images/Group bg.png';
import './TeamMember.css';

const connectTextBg = {
    backgroundImage: `url(${bodyLeftBg})`,
    backgroundPosition: 'left top',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100% 80%'
}
const connectTextBgLg = {
    backgroundImage: `url(${bodyLeftBg})`,
    backgroundPosition: 'left top',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100% 37%'
}
const testimonialBgLg = {
    backgroundImage: `url(${testimonial})`,
    backgroundPosition: 'left 5.5% top 8%',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '28.4% 80%'
}
const connectBgLg = {
    backgroundImage: `url(${connectBg})`,
    backgroundPosition: 'right bottom',
    backgroundRepeat: 'no-repeat'
}
const teamBgLg = {
    backgroundImage: `url(${groupBg})`,
    backgroundPosition: 'right 10% center',
    backgroundRepeat: 'no-repeat'
}
const NextArrow = ({ onClick }) => {
    return (
        <Box sx={{ py: 1, px: { xs: 1.875, sm: 2.625, md: 3.375, lg: 4.125 } }} className="go nextStep" onClick={onClick}>
            <i className="fas fa-arrow-right"></i>
        </Box>
    );
};

const PrevArrow = ({ onClick }) => {
    return (
        <Box sx={{ py: 1, px: { xs: 1.875, sm: 2.625, md: 3.375, lg: 4.125 } }} className="go previous" onClick={onClick}>
            <i className="fas fa-arrow-left"></i>
        </Box>
    );
};

const TeamMembers = () => {
    var settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 2.2,
        slidesToScroll: 1,
        lazyLoad: true,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
    };
    return (
        <div>
            <Box sx={{ display: { xs: 'inline', sm: 'inline', md: 'none' } }}>
                <Grid container sx={{ mt: 4, mb: 2 }}>
                    <Grid item xs={4} sm={4}>
                        <Box style={connectTextBg} sx={{ pb: 4 }}>
                            <Container>
                                <Box id="banner-textBg" sx={{ textAlign: 'left' }}>
                                    <Typography variant="h3" id="connect-title" sx={{ pt: 1, pb: 3, color: '#000D83', fontWeight: 600, pl: 2.5, py: 4 }}>
                                        Team
                                    </Typography>
                                </Box>
                            </Container>
                        </Box>
                    </Grid>
                    <Grid item xs={8} sm={8} sx={{ textAlign: 'left', pr: 3, display: 'flex', alignItems: 'center' }}>
                        <Typography variant="p" sx={{ color: '#454545', fontSize: { xs: '14px', sm: '18px' } }} >
                            Lorem ipsum dolor sit amet, consectetur adipiscing Amet pharetra, maecena. consectetur adipisciet yarr pharetra
                        </Typography>
                    </Grid>
                </Grid>
                <Container sx={{ mb: 4, mt: 3 }}>
                    <Grid container>
                        <Grid item xs={6}>
                            <Box sx={{ width: '50%', margin: 'auto', p: { xs: 2, sm: 3 }, mb: 4, boxShadow: ' 0px 0px 7px rgba(0, 82, 224, 0.16)', transform: 'skewY(3deg)' }}>
                                <CardMedia
                                    component="img"
                                    sx={{ width: '100%' }}
                                    image={testimonial2}
                                    alt=""
                                />
                                <Typography variant="h6" sx={{ color: '#303030', lineHeight: '20px', py: 1, fontSize: { xs: '12px', sm: '15px' }, fontWeight: 500, transform: 'skewY(-3deg)' }}>
                                    James Buttler
                                </Typography>
                                <Typography variant="h6" sx={{ color: '#303030', lineHeight: '20px', fontSize: '12px', fontWeight: 400, transform: 'skewY(-3deg)' }}>
                                    CEO
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={6}>
                            <Box sx={{ width: '50%', margin: 'auto', p: { xs: 2, sm: 3 }, mb: 4, boxShadow: ' 0px 0px 7px rgba(0, 82, 224, 0.16)', transform: 'skewY(3deg)' }}>
                                <CardMedia
                                    component="img"
                                    sx={{ width: '100%' }}
                                    image={testimonial1}
                                    alt=""
                                />
                                <Typography variant="h6" sx={{ color: '#303030', lineHeight: '20px', py: 1, fontSize: { xs: '12px', sm: '15px' }, fontWeight: 500, transform: 'skewY(-3deg)' }}>
                                    James Buttler
                                </Typography>
                                <Typography variant="h6" sx={{ color: '#303030', lineHeight: '20px', fontSize: '12px', fontWeight: 400, transform: 'skewY(-3deg)' }}>
                                    CEO
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={6}>
                            <Box sx={{ width: '50%', margin: 'auto', p: { xs: 2, sm: 3 }, mt: 4, boxShadow: ' 0px 0px 7px rgba(0, 82, 224, 0.16)', transform: 'skewY(3deg)' }}>
                                <CardMedia
                                    component="img"
                                    sx={{ width: '100%' }}
                                    image={testimonial2}
                                    alt=""
                                />
                                <Typography variant="h6" sx={{ color: '#303030', lineHeight: '20px', py: 1, fontSize: { xs: '12px', sm: '15px' }, fontWeight: 500, transform: 'skewY(-3deg)' }}>
                                    James Buttler
                                </Typography>
                                <Typography variant="h6" sx={{ color: '#303030', lineHeight: '20px', fontSize: '12px', fontWeight: 400, transform: 'skewY(-3deg)' }}>
                                    CEO
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={6}>
                            <Box sx={{ width: '50%', margin: 'auto', p: { xs: 2, sm: 3 }, mt: 4, boxShadow: ' 0px 0px 7px rgba(0, 82, 224, 0.16)', transform: 'skewY(3deg)' }}>
                                <CardMedia
                                    component="img"
                                    sx={{ width: '100%' }}
                                    image={testimonial1}
                                    alt=""
                                />
                                <Typography variant="h6" sx={{ color: '#303030', lineHeight: '20px', py: 1, fontSize: { xs: '12px', sm: '15px' }, fontWeight: 500, transform: 'skewY(-3deg)' }}>
                                    James Buttler
                                </Typography>
                                <Typography variant="h6" sx={{ color: '#303030', lineHeight: '20px', fontSize: '12px', fontWeight: 400, transform: 'skewY(-3deg)' }}>
                                    CEO
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </Container>
            </Box>
            <Box sx={{ display: { xs: 'none', sm: 'none', md: 'inline' } }}>
                <Grid container sx={{ py: 8 }} className='large-display'>
                    <Grid item md={3}>
                        <Box style={connectTextBgLg} sx={{ pb: 4, pl: { md: '10%', lg: '26%' } }}>
                            <Box id="banner-textBg" sx={{ textAlign: 'left' }}>
                                <Typography variant="h3" id="connect-title" sx={{ pt: 1, pb: 3, color: '#000D83', fontWeight: 600, pl: 2.5, py: 4 }}>
                                    Team
                                </Typography>
                            </Box>
                            <Box sx={{ textAlign: 'left', px: { md: 2, lg: 3 }, my: 3 }}>
                                <Typography variant="p" sx={{ color: '#454545', fontSize: '18px' }}>
                                    Lorem ipsum dolor sit amet, consectetur adipiscing Amet pharetra, maecena. consectetur adipisciet yarr pharetra
                                </Typography>
                            </Box>
                        </Box>
                    </Grid>
                    <Grid item md={9} style={connectBgLg}>
                        <Box sx={{ position: 'relative' }} style={testimonialBgLg}>
                            <Box style={teamBgLg}>
                                <Slider {...settings}>
                                    <Box sx={{ mb: { md: 7.33, lg: 9.375 }, ml: 5 }}>
                                        <Box sx={{ width: '50%', margin: 'auto', p: { xs: 2, sm: 3 }, mt: 4, boxShadow: ' 0px 0px 7px rgba(0, 82, 224, 0.16)', transform: 'skewY(3deg)', background: '#ffffff', borderRadius: 2 }}>
                                            <CardMedia
                                                component="img"
                                                sx={{ width: '100%' }}
                                                image={testimonial2}
                                                alt=""
                                            />
                                            <Typography variant="h6" sx={{ color: '#303030', lineHeight: '20px', py: 2, fontSize: { md: '22px', lg: '25px' }, fontWeight: 500, transform: 'skewY(-3deg)' }}>
                                                James Buttler
                                            </Typography>
                                            <Typography variant="h6" sx={{ color: '#303030', lineHeight: '20px', fontSize: { md: '14px', lg: '18px' }, fontWeight: 400, transform: 'skewY(-3deg)' }}>
                                                CEO
                                            </Typography>
                                        </Box>
                                    </Box>

                                    <Box sx={{ ml: 5 }}>
                                        <Box sx={{ width: '50%', margin: 'auto', p: { xs: 2, sm: 3 }, mt: 4, boxShadow: ' 0px 0px 7px rgba(0, 82, 224, 0.16)', transform: 'skewY(3deg)', background: '#ffffff', borderRadius: 2 }}>
                                            <CardMedia
                                                component="img"
                                                sx={{ width: '100%' }}
                                                image={testimonial1}
                                                alt=""
                                            />
                                            <Typography variant="h6" sx={{ color: '#303030', lineHeight: '20px', py: 2, fontSize: { md: '22px', lg: '25px' }, fontWeight: 500, transform: 'skewY(-3deg)' }}>
                                                Sophia Olsen
                                            </Typography>
                                            <Typography variant="h6" sx={{ color: '#303030', lineHeight: '20px', fontSize: { md: '14px', lg: '18px' }, fontWeight: 400, transform: 'skewY(-3deg)' }}>
                                                COO
                                            </Typography>
                                        </Box>
                                    </Box>

                                    <Box sx={{ ml: 5 }}>
                                        <Box sx={{ width: '50%', margin: 'auto', p: { xs: 2, sm: 3 }, mt: 4, boxShadow: ' 0px 0px 7px rgba(0, 82, 224, 0.16)', transform: 'skewY(3deg)', background: '#ffffff', borderRadius: 2 }}>
                                            <CardMedia
                                                component="img"
                                                sx={{ width: '100%' }}
                                                image={testimonial2}
                                                alt=""
                                            />
                                            <Typography variant="h6" sx={{ color: '#303030', lineHeight: '20px', py: 2, fontSize: { md: '22px', lg: '25px' }, fontWeight: 500, transform: 'skewY(-3deg)' }}>
                                                James Buttler
                                            </Typography>
                                            <Typography variant="h6" sx={{ color: '#303030', lineHeight: '20px', fontSize: { md: '14px', lg: '18px' }, fontWeight: 400, transform: 'skewY(-3deg)' }}>
                                                CEO
                                            </Typography>
                                        </Box>
                                    </Box>

                                    <Box sx={{ ml: 5 }}>
                                        <Box sx={{ width: '50%', margin: 'auto', p: { xs: 2, sm: 3 }, mt: 4, boxShadow: ' 0px 0px 7px rgba(0, 82, 224, 0.16)', transform: 'skewY(3deg)', background: '#ffffff', borderRadius: 2 }}>
                                            <CardMedia
                                                component="img"
                                                sx={{ width: '100%' }}
                                                image={testimonial1}
                                                alt=""
                                            />
                                            <Typography variant="h6" sx={{ color: '#303030', lineHeight: '20px', py: 2, fontSize: { md: '22px', lg: '25px' }, fontWeight: 500, transform: 'skewY(-3deg)' }}>
                                                Sophia Olsen
                                            </Typography>
                                            <Typography variant="h6" sx={{ color: '#303030', lineHeight: '20px', fontSize: { md: '14px', lg: '18px' }, fontWeight: 400, transform: 'skewY(-3deg)' }}>
                                                COO
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Slider>
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </div>
    );
};

export default TeamMembers;